import { css } from '@emotion/core'

export default () => css`
.hero-banner.category-page {
    height: 600px;
    padding-bottom: 70px;
    -webkit-align-items: end;
    -moz-align-items: end;
    -ms-align-items: end;
    align-items: end;
}
  
.hero-banner.category-page .banner-content-section {
    width: 500px;
}
  
.hero-banner.category-page .banner-heading {
    font-size: 42px;
    line-height: 52px;
}
  
@media (max-width: 767px) {
    .hero-banner.category-page { 
        height: 680px;
    }

    .hero-banner.category-page .banner-container {
        padding: 0;
    }

    .hero-banner.category-page .banner-content-section {
        width: 100%;
    }

    .hero-banner.category-page .banner-heading {
        font-size: 37px;
        line-height: 43px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .hero-banner.category-page {
      background-position: right center;
    }
}

.hero-banner {
    width: 100%;
    height: 730px;
    background-repeat: no-repeat;
    background-size: cover;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    align-items: center;
}
  
.hero-banner .banner-container {
    width: 1264px;
    margin: 0 auto;
    padding: 0 120px;
}

.hero-banner .banner-content-section {
    width: 500px;
    color: #fff;
}

.hero-banner .banner-title {
    margin-bottom: 8px;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1.1px;
}

.hero-banner .banner-heading {
    margin-bottom: 16px;
    font-family: "Switzer-Semibold", sans-serif;
    font-size: 64px;
    line-height: 72px;
}
  
.hero-banner .banner-header-title {
    margin-bottom: 26px;
    font-size: 14px;
    line-height: 22px;
}

.hero-banner .banner-link {
    color: #fff;
    font-size: 14px;
    text-decoration: underline;
    letter-spacing: 1.5px;
    text-transform: uppercase;
}
    
.hero-banner .banner-link:hover {
    text-decoration: none;
}
  
@media (max-width: 767px) {
    .hero-banner {
        height: 680px;
        padding-bottom: 42px;
        -webkit-align-items: end;
        -moz-align-items: end;
        -ms-align-items: end;
        align-items: end;
    }
    
    .hero-banner .banner-container {
        width: 100%;
        padding: 0 20px;
    }
      
    .hero-banner .banner-content-section {
        width: 100%;
        padding: 0 25px;
    }
    
    .hero-banner .banner-heading {
        font-size: 45px;
        line-height: 50px;
    }
    
    .hero-banner .banner-header-title {
        font-size: 12px;
        line-height: 18px;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .hero-banner {
        padding: 0 50px;
    }
}

@media (min-width: 1024px) and (max-width: 1399px) {
    .hero-banner {
        padding: 0 40px;
        background-position: right center;
    }
}
`